import type { Org } from "../../lib/types";

export const ORG_TABS = [
  { key: "home", label: "Home" },
  { key: "visibility", label: "Visibility" },
  { key: "activity", label: "Activity" },
  { key: "assets", label: "Inventory" },
  { key: "budgets", label: "Governance" },
  { key: "plans", label: "People" },
  { key: "models", label: "Model pricing" },
  { key: "settings", label: "Settings" },
] as const;

export type OrgTab = (typeof ORG_TABS)[number]["key"];

export function canManageDevices(
  org: Pick<Org, "role" | "device_management"> | null,
): boolean {
  return org?.role === "org:admin" && org.device_management === true;
}

// Hashes from before the rename keep landing somewhere sensible.
export const ORG_TAB_ALIASES: Record<string, OrgTab> = {
  dashboard: "home",
  analytics: "visibility",
  costs: "visibility",
  governance: "budgets",
  productivity: "home",
  coach: "home",
  people: "plans",
  members: "plans",
  devices: "plans",
};

export function orgTabs(org: Pick<Org, "reselling" | "sub_credited"> | null) {
  return ORG_TABS.filter((t) => t.key !== "models" || !!org?.reselling);
}
